export enum SaveMessageState {
  Pending,
  Saved,
  None
}
